import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';
import api from './api';
import { notification } from '@digital/ui';

export interface Template {
  arquivo: arquivo;
  createdAt?: string;
  descricaoDocumento: string;
  id: string;
  tipoServicoId?: string;
}

interface arquivo{
  extensao: string;
  id: string;
  local: string;
  nome: string;
  vigente: boolean;
}

export interface TemplateFilter {
  tipoServicoId: string;
  descricaoDocumento: string;
}

export const search = (values: TemplateFilter) => {
  return api.post<Template[]>('templates/search', values, {
    disableNotification: 'true',
  });
};

export const create = (values: any) => {
  const form = new FormData();
  Object.keys(values).forEach(key => {
    form.append(key, values[key]);
  });
  return api.put<any>('templates/create', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const excluir = (id: string) => {
  return api.delete(`templates/${id}`);
};

export const viewArquivo = async (id, nome) => {
  var url = window.location.origin + `/api/templates/DownloadArquivo/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nome);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};

export const downloadArquivo = (id: string, nome: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/DownloadArquivo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};

export const baixarTudo = values => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.post(urlBase + `/api/templates/DownloadTudo`, values, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'templates.zip');
      link.setAttribute('id', 'downloadArquivo');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadArquivo').outerHTML = '';
    }),
  );
};

export const baixarTemplatesDemanda = (demandaId: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplatesDemanda/${demandaId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'templates.zip');
        link.setAttribute('id', 'downloadArquivo');
        document.body.appendChild(link);
        link.click();
        document.getElementById('downloadArquivo').outerHTML = '';
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Templates não encontrados.');
          }
        }
      }),
  );
};

export const baixarTemplateRiskAssessment = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateRiskAssessment`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};

export const baixarTemplateFormularioReqCompra = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateFormularioReqCompra`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};

export const baixarTemplateCartaConvite = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateCartaConvite`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};



export const baixarTemplateNomeacaoGestorFornecedor = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateNomeacaoGestorFornecedor`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};

export const baixarTemplateCartaAgradecimento = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateCartaAgradecimento`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};

export const baixarTemplateTakeOffAditivoPCS = () => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/templates/GetTemplateTakeOffAditivoPCS`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    })
      .then(resp => {
        let headerLine = resp.headers['content-disposition'];
        let contents = headerLine.split('; ');
        let filename = '';
        contents.forEach(element => {
          if (element.includes('filename=')) {
            filename = element.replace('filename=', '').replaceAll('"', '');
          }
        });
        if (filename !== '') {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          link.setAttribute('id', 'downloadArquivo');
          document.body.appendChild(link);
          link.click();
          document.getElementById('downloadArquivo').outerHTML = '';
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 404) {
            notification.error('Template não encontrado.');
          }
        }
      }),
  );
};
